import { render, staticRenderFns } from "./AboutSetting.vue?vue&type=template&id=2deaf154"
import script from "./AboutSetting.vue?vue&type=script&lang=js"
export * from "./AboutSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports